import type { FC } from 'react'
import type { SvgIconProps } from '@mui/material'

import { assert } from '../../../utils'

import { ConnectwareError, ConnectwareErrorType } from '../../../domain'

import { type AbsoluteRouteOnlyPath, useRouteFormatter } from '../routing'
import { getNavigationConfig } from './Config'

export const useNavigationFormatter = useRouteFormatter.extend(
    (RouteFormatter) =>
        class extends RouteFormatter {
            formatDescription (routePath: AbsoluteRouteOnlyPath): string | null {
                const description = getNavigationConfig(routePath, 'description')
                return description ? this.translator.formatTranslation(description) : null
            }

            formatIcon (routePath: AbsoluteRouteOnlyPath): FC<SvgIconProps> {
                const icon = getNavigationConfig(routePath, 'icon')
                assert(icon, new ConnectwareError(ConnectwareErrorType.UNEXPECTED, 'This route must have an icon', { routePath }))
                return icon
            }
        },
    'useNavigationFormatter'
)
